import {
    clientHasPackerPickerPerformanceReportAccess,
    clientHasPackerProductSummaryReportAccess,
    clientHasPackerSummaryReportAccess,
    clientHasPackerToolsAccess,
    clientsHaveIntegration,
    is7Eleven,
    userHasAccess,
    userHasFeature,
    userIsContractor,
    userIsHDSStaff,
    userIsDev,
    userIsAMemberOfClientId,
    clientsHaveConfiguration,
} from '../util/hasAccess';

const SiteNavItems = (
    showNav,
    auth,
    config,
    notifications,
    clients,
    canViewZones,
    currentClientFallback
) => {
    const errorReportingClientIds = [8, 14, 363];

    let canUploadCsv = false;
    if (userIsHDSStaff(auth.user.role)) {
        canUploadCsv = true;
    } else {
        canUploadCsv =
            clients.items?.filter((client) => {
                return client.configuration?.allowCsvManifestUpload === true;
            }).length > 0;
    }

    const currentClient =
        clients.items?.find((client) => client.id === auth.user.clientId) ??
        currentClientFallback;

    return [
        {
            condition: showNav,
            classNames: 'deliveries receival pb-0',
            items: [
                {
                    type: 'linkNew',
                    component: 'OrderSearchLink',
                    condition: userHasAccess(auth.user.role, 'order-search'),
                },
            ],
        },
        {
            condition: showNav,
            classNames: 'deliveries receival pb-0',
            items: [
                {
                    type: 'heading',
                    text: 'Deliveries',
                },
                {
                    type: 'linkNew',
                    component: 'DashboardLink',
                    condition: !userIsContractor(auth.user.role),
                },
                {
                    type: 'component',
                    component: 'DeliveriesByStateNoHeadingLink',
                },
                {
                    type: 'linkNew',
                    component: 'DeliveryErrorsLink',
                    condition:
                        userHasAccess(auth.user.role, 'errors') ||
                        errorReportingClientIds.includes(auth.user.clientId),
                },
                {
                    type: 'linkNew',
                    component: 'RunDropErrorsLink',
                    condition: userIsHDSStaff(auth.user.role),
                },
                {
                    type: 'link',
                    component: 'ClientViewErrorsLink',
                    condition:
                        userIsHDSStaff(auth.user.role) ||
                        userHasFeature(auth.user, 'ClientViewErrors', '1'),
                },
                {
                    type: 'linkNew',
                    component: 'BetaDeliveriesLink',
                    condition:
                        config.betaURI && auth.user.role !== 'contractor',
                },
                {
                    type: 'linkNew',
                    component: 'BetaDeliveriesGeoIssueLink',
                    condition:
                        config.betaURI && auth.user.role !== 'contractor',
                },
                {
                    type: 'linkNew',
                    component: 'RunsLink',
                    condition:
                        config.betaURI &&
                        (auth.user.role == 'admin' ||
                            (userIsContractor(auth.user.role) &&
                                userHasFeature(
                                    auth.user,
                                    'ContractorManageRuns',
                                    '*'
                                ))),
                },
                {
                    type: 'linkNew',
                    component: 'BetaBoxesLink',
                    condition:
                        config.betaURI &&
                        clientsHaveIntegration(clients.items, 'auspost'),
                },
                {
                    type: 'linkNew',
                    component: 'RunSummaryLink',
                    condition:
                        config.betaURI &&
                        (userIsHDSStaff(auth.user.role) ||
                            userIsContractor(auth.user.role) ||
                            auth.user.role === 'client-admin' ||
                            auth.user.role === 'client-user'),
                },
                {
                    type: 'linkNew',
                    component: 'FailedSlaLink',
                    condition: userIsHDSStaff(auth.user.role),
                },
                {
                    type: 'linkNew',
                    component: 'LoadoutScreenLink',
                    condition:
                        config.betaURI &&
                        (userIsHDSStaff(auth.user.role) ||
                            userIsContractor(auth.user.role)),
                },
                {
                    type: 'linkNew',
                    component: 'RdsLoadoutDashboardLink',
                    condition: config.betaURI && userIsHDSStaff(auth.user.role),
                },
                {
                    type: 'linkNew',
                    component: 'PostSortationBoxValidationLink',
                    condition:
                        config.betaURI &&
                        userIsHDSStaff(auth.user.role) &&
                        userHasFeature(auth.user, 'PostSortationScreen', '1'),
                },
                {
                    type: 'linkNew',
                    component: 'BoxLoadCheckLink',
                    condition:
                        config.betaURI &&
                        (userIsHDSStaff(auth.user.role) ||
                            userIsAMemberOfClientId(auth.user, 888) ||
                            userIsAMemberOfClientId(auth.user, 821)),
                },
                {
                    type: 'linkNew',
                    component: 'PrimaryConnectLink',
                    condition: config.betaURI && userIsHDSStaff(auth.user.role),
                },
                {
                    type: 'linkNew',
                    component: 'RetailDeliveryBookingsLink',
                    condition:
                        config.betaURI &&
                        userHasFeature(auth.user, 'RetailDeliveryBooking', '1'),
                },
                {
                    type: 'linkNew',
                    component: 'PalletsLink',
                    condition: config.betaURI && userIsHDSStaff(auth.user.role),
                },
                {
                    type: 'linkNew',
                    component: 'PalletsSummaryLink',
                    condition: config.betaURI && userIsHDSStaff(auth.user.role),
                },
                {
                    type: 'linkNew',
                    component: 'AppLogLink',
                    condition: config.betaURI && userIsDev(auth.user),
                },
            ],
        },
        {
            condition: showNav,
            classNames: 'deliveries receival pb-0',
            items: [
                {
                    type: 'heading',
                    text: 'Delivery Confirmations',
                },
                {
                    type: 'linkNew',
                    component: 'WholesaleDeliveriesLink',
                    condition: userHasAccess(
                        auth.user.role,
                        'wholesale-deliveries'
                    ),
                },
                {
                    type: 'linkNew',
                    component: 'HomeDeliveriesConfirmLink',
                    condition: userHasAccess(
                        auth.user.role,
                        'home-deliveries-confirm'
                    ),
                },
                {
                    type: 'linkNew',
                    component: 'TemperatureCheckConfirmationLink',
                    condition: userHasAccess(
                        auth.user.role,
                        'temp-check-confirmation'
                    ),
                },
                {
                    type: 'link',
                    component: 'DropInstructionsFollowedLink',
                    condition: userHasAccess(
                        auth.user.role,
                        'drop-instructions-followed'
                    ),
                },
                {
                    type: 'linkNew',
                    component: 'CustomerChangeRequestsLink',
                    condition: userHasAccess(
                        auth.user.role,
                        'customer-updates'
                    ),
                    notifications: notifications?.customerChangeRequests || 0,
                },
                {
                    type: 'linkNew',
                    component: 'CustomerChangeRequestsLinkBeta',
                    condition: userHasAccess(
                        auth.user.role,
                        'customer-updates'
                    ),
                    notifications:
                        notifications?.deliveryCustomerChangeRequests || 0,
                },
                {
                    type: 'linkNew',
                    component: 'ZoneLookupLink',
                    condition: !userIsContractor(auth.user.role),
                },
            ],
        },
        {
            condition: showNav,
            classNames: 'deliveries receival pb-0',
            items: [
                {
                    type: 'heading',
                    text: 'Reports',
                },
                {
                    type: 'linkNew',
                    component: 'DeliveriesSummaryLink',
                    condition:
                        showNav &&
                        userHasAccess(auth.user.role, 'dashboard-summary'),
                },
                {
                    type: 'linkNew',
                    component: 'ErrorRateLink',
                    condition:
                        userHasAccess(auth.user.role, 'error-rate') ||
                        errorReportingClientIds.includes(auth.user.clientId),
                },
                {
                    type: 'linkNew',
                    component: 'TimeWindowReportOverviewLink',
                    condition: userHasAccess(auth.user.role, 'order-search'),
                },
                {
                    type: 'linkNew',
                    component: 'NewOrderETALink',
                    condition: userHasAccess(auth.user.role, 'order-search'),
                },
                {
                    type: 'linkNew',
                    component: 'ZoneSuburbReportLink',
                    condition: userHasAccess(
                        auth.user.role,
                        'zone-suburb-report'
                    ),
                },
                {
                    type: 'link',
                    component: 'CustomerFeedbackNLink',
                    condition: config.betaURI && userIsHDSStaff(auth.user.role),
                },
                {
                    type: 'linkNew',
                    component: 'AuspostDataReportLink',
                    condition:
                        config.betaURI &&
                        clientsHaveIntegration(clients.items, 'auspost'),
                },
                {
                    type: 'linkNew',
                    component: 'BetaAPReportLink',
                    condition:
                        config.betaURI &&
                        clientsHaveIntegration(clients.items, 'auspost'),
                },
                {
                    type: 'linkNew',
                    component: 'ContractorPerformanceReportLink',
                    condition:
                        config.betaURI &&
                        auth.user.role === 'admin' &&
                        userHasFeature(
                            auth.user,
                            'ContractorPerformanceReport',
                            '1'
                        ),
                },
                {
                    type: 'linkNew',
                    component: 'ContractorPaySummaryLink',
                    condition:
                        config.betaURI &&
                        auth.user.role === 'contractor' &&
                        userHasFeature(
                            auth.user,
                            'ContractorAccessPaySummary',
                            '1'
                        ),
                },
                {
                    type: 'linkNew',
                    component: 'ContractorPayLedgerSummaryLink',
                    condition:
                        config.betaURI &&
                        auth.user.role === 'contractor' &&
                        userHasFeature(
                            auth.user,
                            'ContractorAccessPaySummary',
                            '1'
                        ),
                },
                {
                    type: 'linkNew',
                    component: 'DriverPerformanceReportLink',
                    condition:
                        config.betaURI &&
                        (auth.user.role === 'admin' ||
                            (userIsContractor(auth.user.role) &&
                                userHasFeature(
                                    auth.user,
                                    'ContractorCanViewDriverPerformanceReport',
                                    '*'
                                ))),
                },
            ],
        },
        {
            condition: showNav,
            classNames: 'deliveries receival pb-0',
            items: [
                {
                    type: 'heading',
                    text: 'Admin',
                },
                {
                    type: 'linkNew',
                    component: 'SMSScheduleLink',
                    condition: userHasAccess(auth.user.role, 'sms-schedule'),
                },
                {
                    type: 'link',
                    component: 'SMSBlockLink',
                    condition: userHasAccess(auth.user.role, 'sms-block'),
                },
            ],
        },
        {
            condition:
                showNav && userHasFeature(auth.user, 'FinancialReporting', '*'),
            classNames: 'deliveries receival pb-0',
            items: [
                {
                    type: 'heading',
                    text: 'Financial Reporting',
                },
                {
                    type: 'linkNew',
                    component: 'FRImportRatesLink',
                    condition:
                        userHasFeature(
                            auth.user,
                            'FinancialReporting',
                            'all'
                        ) ||
                        userHasFeature(
                            auth.user,
                            'FinancialReporting',
                            'import-rates'
                        ),
                },
                {
                    type: 'linkNew',
                    component: 'FRRateMasterLink',
                    condition:
                        userHasFeature(
                            auth.user,
                            'FinancialReporting',
                            'all'
                        ) ||
                        userHasFeature(
                            auth.user,
                            'FinancialReporting',
                            'rate-master'
                        ),
                },
                {
                    type: 'linkNew',
                    component: 'FRRateBulkUpdateLink',
                    condition:
                        userHasFeature(
                            auth.user,
                            'RateMasterBulkUpdate',
                            '*'
                        ) &&
                        (userHasFeature(
                            auth.user,
                            'FinancialReporting',
                            'all'
                        ) ||
                            userHasFeature(
                                auth.user,
                                'FinancialReporting',
                                'rate-master'
                            )),
                },
                {
                    type: 'linkNew',
                    component: 'FRFuelCategoryLink',
                    condition:
                        (userIsHDSStaff(auth.user.role) &&
                            userHasFeature(
                                auth.user,
                                'FinancialReporting',
                                'all'
                            )) ||
                        userHasFeature(
                            auth.user,
                            'FinancialReporting',
                            'fuel-category'
                        ),
                },
                {
                    type: 'linkNew',
                    component: 'FRRevenueReportLink',
                    condition:
                        userHasFeature(
                            auth.user,
                            'FinancialReporting',
                            'all'
                        ) ||
                        userHasFeature(
                            auth.user,
                            'FinancialReporting',
                            'revenue-report'
                        ),
                },
                {
                    type: 'linkNew',
                    component: 'FRRatesByClientLink',
                    condition:
                        userHasFeature(
                            auth.user,
                            'FinancialReporting',
                            'all'
                        ) ||
                        userHasFeature(
                            auth.user,
                            'FinancialReporting',
                            'rates-by-client'
                        ),
                },
                {
                    type: 'linkNew',
                    component: 'FRPayRatesLink',
                    condition:
                        userHasFeature(
                            auth.user,
                            'FinancialReporting',
                            'all'
                        ) ||
                        userHasFeature(
                            auth.user,
                            'FinancialReporting',
                            'pay-rates'
                        ),
                },
                {
                    type: 'linkNew',
                    component: 'FRDriverPayReportLink',
                    condition:
                        userHasFeature(
                            auth.user,
                            'FinancialReporting',
                            'all'
                        ) ||
                        userHasFeature(
                            auth.user,
                            'FinancialReporting',
                            'driver-pay'
                        ),
                },
                {
                    type: 'linkNew',
                    component: 'FRRunFinesLink',
                    condition:
                        userHasFeature(
                            auth.user,
                            'FinancialReporting',
                            'all'
                        ) ||
                        userHasFeature(
                            auth.user,
                            'FinancialReporting',
                            'run-fines'
                        ),
                },
                {
                    type: 'linkNew',
                    component: 'FRContractorLedgerLink',
                    condition:
                        userHasFeature(
                            auth.user,
                            'FinancialReporting',
                            'all'
                        ) ||
                        userHasFeature(
                            auth.user,
                            'FinancialReporting',
                            'contractor-ledger'
                        ),
                },
                {
                    type: 'linkNew',
                    component: 'FRFuelSurcharge',
                    condition:
                        userHasFeature(
                            auth.user,
                            'FinancialReporting',
                            'all'
                        ) ||
                        userHasFeature(
                            auth.user,
                            'FinancialReporting',
                            'fuel-surcharges'
                        ) ||
                        userHasFeature(
                            auth.user,
                            'FinancialReporting',
                            'fuel-surcharges-edit'
                        ),
                },
                {
                    type: 'linkNew',
                    component: 'FRClientInvoicingItemisedLink',
                    condition:
                        userHasFeature(
                            auth.user,
                            'FinancialReporting',
                            'all'
                        ) ||
                        userHasFeature(
                            auth.user,
                            'FinancialReporting',
                            'client-invoice'
                        ),
                },
            ],
        },
        {
            condition: showNav,
            classNames: 'deliveries receival pb-0',
            items: [
                {
                    type: 'heading',
                    text: 'Drivers/Contractors',
                },
                {
                    type: 'linkNew',
                    component: 'BetaContractorsLink',
                    condition: config.betaURI && auth.user.role === 'admin',
                },
                {
                    type: 'linkNew',
                    component: 'BetaContractorAssignLink',
                    condition: config.betaURI && auth.user.role === 'admin',
                },
                {
                    type: 'linkNew',
                    component: 'BetaDriverAssignLink',
                    condition:
                        config.betaURI &&
                        (auth.user.role === 'admin' ||
                            auth.user.role === 'contractor'),
                },
                {
                    type: 'linkNew',
                    component: 'RunAutoAssignLink',
                    condition: userHasFeature(
                        auth.user,
                        'ControlRunAutoAssign',
                        '1'
                    ),
                },
                {
                    type: 'linkNew',
                    component: 'BetaVanAvailabilityLink',
                    condition:
                        config.betaURI &&
                        (auth.user.role === 'admin' ||
                            auth.user.role === 'contractor'),
                },
                {
                    type: 'linkNew',
                    component: 'BetaVanAvailabilityReportLink',
                    condition: config.betaURI && auth.user.role === 'admin',
                },
                {
                    type: 'linkNew',
                    component: 'DriverAppVersionReportLink',
                    condition: config.betaURI && auth.user.role === 'admin',
                },
                {
                    type: 'linkNew',
                    component: 'DriverErrorsReportLink',
                    condition: config.betaURI && auth.user.role === 'admin',
                },
                {
                    type: 'linkNew',
                    component: 'ContractorViewErrorsLink',
                    condition:
                        auth.user.role === 'admin' ||
                        (auth.user.role === 'contractor' &&
                            userHasFeature(
                                auth.user,
                                'RunDropErrorViewer',
                                '1'
                            )),
                },
            ],
        },
        {
            condition: showNav,
            classNames: 'deliveries receival pb-0',
            items: [
                {
                    type: 'heading',
                    text: 'Line Haul',
                },
                {
                    type: 'linkNew',
                    component: 'LineHaulJobsLink',
                    condition: config.betaURI && userIsHDSStaff(auth.user.role),
                },
                {
                    type: 'linkNew',
                    component: 'ClientLineHaulJobsLink',
                    condition:
                        config.betaURI &&
                        userHasFeature(auth.user, 'LineHaulJob', '1'),
                },
                {
                    type: 'linkNew',
                    component: 'LineHaulJobAcceptanceLink',
                    condition: config.betaURI && auth.user.role === 'admin',
                },
                {
                    type: 'linkNew',
                    component: 'LineHaulMovementsBuilderLink',
                    condition: config.betaURI && auth.user.role === 'admin',
                },
                {
                    type: 'linkNew',
                    component: 'LineHaulMovementsAllocatorLink',
                    condition: config.betaURI && auth.user.role === 'admin',
                },
                {
                    type: 'linkNew',
                    component: 'LineHaulMovementsLink',
                    condition: config.betaURI && auth.user.role === 'admin',
                },
                {
                    type: 'linkNew',
                    component: 'LineHaulTruckLink',
                    condition: config.betaURI && auth.user.role === 'admin',
                },
                {
                    type: 'linkNew',
                    component: 'LineHaulTrailerLink',
                    condition: config.betaURI && auth.user.role === 'admin',
                },
                {
                    type: 'linkNew',
                    component: 'LineHaulLegLink',
                    condition: config.betaURI && auth.user.role === 'admin',
                },
                {
                    type: 'linkNew',
                    component: 'LineHaulSubcontractorLink',
                    condition: config.betaURI && auth.user.role === 'admin',
                },
                {
                    type: 'linkNew',
                    component: 'LineHaulDollyLink',
                    condition: config.betaURI && auth.user.role === 'admin',
                },
                {
                    type: 'linkNew',
                    component: 'LineHaulLegScheduleLink',
                    condition: config.betaURI && auth.user.role === 'admin',
                },
                {
                    type: 'linkNew',
                    component: 'LineHaulScheduleLink',
                    condition: config.betaURI && auth.user.role === 'admin',
                },
                {
                    type: 'linkNew',
                    component: 'LineHaulScoreboardLink',
                    condition: config.betaURI && auth.user.role === 'admin',
                },
            ],
        },
        {
            condition: showNav,
            classNames: 'deliveries receival pb-0',
            items: [
                {
                    type: 'heading',
                    text: 'Operations',
                },
                {
                    type: 'linkNew',
                    component: 'ScanningReportLink',
                    condition:
                        userHasAccess(auth.user.role, 'scanning-report') ||
                        userHasFeature(
                            auth.user,
                            'ContractorCanViewScanReport',
                            '1'
                        ),
                },
                {
                    type: 'linkNew',
                    component: 'ReturnedtoDepotLink',
                    condition: userHasAccess(auth.user.role, 'return-to-depot'),
                },
                {
                    type: 'linkNew',
                    component: 'RedeliveryBoxesLink',
                    condition: config.betaURI && userIsHDSStaff(auth.user.role),
                },
                {
                    type: 'linkNew',
                    component: 'RoutingSummaryLink',
                    condition: userHasAccess(auth.user.role, 'routing-summary'),
                },
                {
                    type: 'linkNew',
                    component: 'PreDeliveriesManageLink',
                    condition: auth.user.role === 'admin',
                },
                {
                    type: 'linkNew',
                    component: 'ControlCenterLink',
                    condition: userIsHDSStaff(auth.user.role),
                },
                {
                    type: 'linkNew',
                    component: 'ClientControlCenterLink',
                    condition:
                        userIsHDSStaff(auth.user.role) ||
                        auth.user.role === 'client-admin' ||
                        auth.user.role === 'client-user',
                },
            ],
        },
        {
            condition: showNav,
            classNames: 'deliveries receival pb-0',
            items: [
                {
                    type: 'heading',
                    text: 'Routing',
                },
                {
                    type: 'linkNew',
                    component: 'AdionaSyncLink',
                    condition: userHasAccess(auth.user.role, 'sync'),
                },
                {
                    type: 'linkNew',
                    component: 'RetailRoutePlannerLink',
                    condition: userHasFeature(
                        auth.user,
                        'RetailRoutePlannerView',
                        '*'
                    ),
                },
                {
                    type: 'linkNew',
                    component: 'ManualRoutingLink',
                    condition: config.betaURI && auth.user.role === 'admin',
                },
                {
                    type: 'linkNew',
                    component: 'ZonesLink',
                    condition:
                        userHasAccess(auth.user.role, 'zones') || canViewZones,
                },
            ],
        },
        {
            condition: userHasAccess(auth.user.role, 'packer'),
            classNames: 'deliveries receival pb-0',
            items: [
                {
                    type: 'heading',
                    text: 'Pick/Pack',
                },
                {
                    type: 'linkNew',
                    component: 'SummaryReportLink',
                    condition:
                        clientHasPackerSummaryReportAccess(currentClient),
                },
                {
                    type: 'linkNew',
                    component: 'ProductSummaryReportLink',
                    condition:
                        clientHasPackerProductSummaryReportAccess(
                            currentClient
                        ) && !is7Eleven(auth.user.clientId),
                },
                {
                    type: 'linkNew',
                    component: 'PickerPerformanceReportsLink',
                    condition:
                        clientHasPackerPickerPerformanceReportAccess(
                            currentClient
                        ) && !is7Eleven(auth.user.clientId),
                },
                {
                    type: 'linkNew',
                    component: 'FloorsLink',
                    condition:
                        config.betaURI &&
                        auth.user.role === 'admin' &&
                        !is7Eleven(auth.user.clientId),
                },
                {
                    type: 'linkNew',
                    component: 'SuppliersLink',
                    condition:
                        config.betaURI &&
                        auth.user.role === 'admin' &&
                        userHasFeature(auth.user, 'PackerSupplier', '1'),
                },
                {
                    type: 'linkNew',
                    component: 'ProductManagementLink',
                    condition:
                        userHasAccess(auth.user.role, 'packer') &&
                        clientHasPackerToolsAccess(currentClient) &&
                        !is7Eleven(auth.user.clientId),
                },
                {
                    type: 'linkNew',
                    component: 'OrderBoxItemStatusesLink',
                    condition:
                        userHasAccess(auth.user.role, 'packer') &&
                        clientHasPackerToolsAccess(currentClient) &&
                        !is7Eleven(auth.user.clientId),
                },
                {
                    type: 'linkNew',
                    component: 'WMSProductsLink',
                    condition:
                        config.betaURI &&
                        clientsHaveIntegration(clients.items, 'dotwms') &&
                        !is7Eleven(auth.user.clientId),
                },
                {
                    type: 'linkNew',
                    component: 'WMSLogsLink',
                    condition:
                        config.betaURI &&
                        auth.user.role === 'admin' &&
                        clientsHaveIntegration(clients.items, 'dotwms') &&
                        !is7Eleven(auth.user.clientId),
                },
                {
                    type: 'linkNew',
                    component: 'BetaWMSOrderItemsLink',
                    condition:
                        config.betaURI &&
                        clientsHaveIntegration(clients.items, 'dotwms') &&
                        !is7Eleven(auth.user.clientId),
                },
                {
                    type: 'linkNew',
                    component: 'WarehouseInventoryLink',
                    condition:
                        config.betaURI &&
                        clientsHaveIntegration(clients.items, 'dotwms'),
                },
                {
                    type: 'linkNew',
                    component: 'InventoryStockAdjustmentsLink',
                    condition:
                        userHasFeature(auth.user, 'InventoryAdjustment', '1') &&
                        auth.user.role === 'admin',
                },
                {
                    type: 'link',
                    component: 'InventoryStockAdjustmentsV2Link',
                    condition:
                        userHasFeature(auth.user, 'InventoryV2', '1') &&
                        auth.user.role === 'admin',
                },
                {
                    type: 'link',
                    component: 'InventoryV2Link',
                    condition:
                        userHasFeature(auth.user, 'InventoryV2', '1') &&
                        auth.user.role === 'admin',
                },
                {
                    type: 'link',
                    component: 'InventoryV2LogLink',
                    condition:
                        userHasFeature(auth.user, 'InventoryV2', '1') &&
                        auth.user.role === 'admin',
                },
                {
                    type: 'linkNew',
                    component: 'WarehousesLink',
                    condition:
                        config.betaURI &&
                        auth.user.role === 'admin' &&
                        !is7Eleven(auth.user.clientId),
                },
                {
                    type: 'linkNew',
                    component: 'BetaPurchaseOrdersLink',
                    condition:
                        config.betaURI && auth.user.role !== 'contractor',
                },
                {
                    type: 'link',
                    component: 'BetaAdvancedShippingNoticesLink',
                    condition: config.betaURI && userIsHDSStaff(auth.user.role),
                },
                {
                    type: 'linkNew',
                    component: 'BetaWMSSyncedDeliveriesLink',
                    condition:
                        config.betaURI &&
                        clientsHaveIntegration(clients.items, 'dotwms') &&
                        !is7Eleven(auth.user.clientId),
                },
            ],
        },
        {
            condition:
                config.betaURI &&
                (userIsHDSStaff(auth.user.role) || userIsDev(auth.user)),
            classNames: 'deliveries receival pb-0',
            items: [
                {
                    type: 'heading',
                    text: 'Petrol/Convenience',
                },
                {
                    type: 'link',
                    component: 'RunSummaryPetrolConvenienceLink',
                    condition: config.betaURI && userIsHDSStaff(auth.user.role),
                },
                {
                    type: 'link',
                    component: 'SevenElevenOrdersExport',
                    condition: config.betaURI && userIsHDSStaff(auth.user.role),
                },
                {
                    type: 'link',
                    component: 'SevenElevenThawdownArticles',
                    condition:
                        config.betaURI &&
                        auth.user.role === 'admin' &&
                        userIsDev(auth.user),
                },
                {
                    type: 'link',
                    component: 'SevenElevenItemsDashboard',
                    condition:
                        config.betaURI &&
                        (userIsHDSStaff(auth.user.role) ||
                            userIsDev(auth.user)),
                },
            ],
        },
        {
            condition:
                config.betaURI &&
                (userIsHDSStaff(auth.user.role) ||
                    userHasFeature(auth.user, 'RDSStores', '*')),
            classNames: 'deliveries receival pb-0',
            items: [
                {
                    type: 'heading',
                    text: 'RDS',
                },
                {
                    type: 'linkNew',
                    component: 'BetaRDSLink',
                    condition: config.betaURI && userIsHDSStaff(auth.user.role),
                },
                {
                    type: 'linkNew',
                    component: 'BetaRDSStoresLink',
                    condition:
                        config.betaURI &&
                        (userIsHDSStaff(auth.user.role) ||
                            userHasFeature(auth.user, 'RDSStores', '*')),
                },
                {
                    type: 'link',
                    component: 'RDSStoresUploadLink',
                    condition: config.betaURI && userIsHDSStaff(auth.user.role),
                },
                {
                    type: 'linkNew',
                    component: 'BetaRDSServiceProvidersLink',
                    condition: config.betaURI && userIsHDSStaff(auth.user.role),
                },
                {
                    type: 'linkNew',
                    component: 'RDSRunReport',
                    condition: config.betaURI && userIsHDSStaff(auth.user.role),
                },
                {
                    type: 'link',
                    component: 'RetailSkillsLink',
                    condition: config.betaURI && userIsHDSStaff(auth.user.role),
                },
                {
                    type: 'linkNew',
                    component: 'RetailStoresLink',
                    condition:
                        config.betaURI &&
                        (userIsHDSStaff(auth.user.role) ||
                            userIsAMemberOfClientId(auth.user, 888)),
                },
                {
                    type: 'linkNew',
                    component: 'RetailStoresImportLink',
                    condition: config.betaURI && userIsHDSStaff(auth.user.role),
                },
                {
                    type: 'linkNew',
                    component: 'RetailStoresCreateExceptionLink',
                    condition:
                        config.betaURI &&
                        (userIsHDSStaff(auth.user.role) ||
                            userIsAMemberOfClientId(auth.user, 888)),
                },
                {
                    type: 'linkNew',
                    component: 'RetailStoresExceptionDailyReportLink',
                    condition:
                        config.betaURI &&
                        (userIsHDSStaff(auth.user.role) ||
                            userIsAMemberOfClientId(auth.user, 888)),
                },
                {
                    type: 'link',
                    component: 'RDSRoutingToolLink',
                    condition: userHasFeature(auth.user, 'RDSRoutingTool', '1'),
                },
                {
                    type: 'linkNew',
                    component: 'BetaAssetTrackerLink',
                    condition: userIsHDSStaff(auth.user.role),
                },
            ],
        },
        {
            condition:
                config.betaURI &&
                (userIsHDSStaff(auth.user.role) ||
                    clientsHaveConfiguration(
                        clients.items,
                        'leastCostRoutingEnabled',
                        true
                    )),
            classNames: 'deliveries receival pb-0',
            items: [
                {
                    type: 'heading',
                    text: 'Courier Routing',
                },
                {
                    type: 'linkNew',
                    component: 'LCRCarrierLink',
                    condition: config.betaURI && userIsHDSStaff(auth.user.role),
                },
                {
                    type: 'linkNew',
                    component: 'LCRCarrierZoneLink',
                    condition:
                        config.betaURI &&
                        (userIsHDSStaff(auth.user.role) ||
                            clientsHaveConfiguration(
                                clients.items,
                                'leastCostRoutingEnabled',
                                true
                            )),
                },
                {
                    type: 'linkNew',
                    component: 'LCRClientRateLink',
                    condition:
                        config.betaURI &&
                        userIsHDSStaff(auth.user.role) &&
                        userHasFeature(auth.user, 'LCRv2', '*'),
                },
                {
                    type: 'linkNew',
                    component: 'LCRCarrierFuelSurchargesLink',
                    condition: config.betaURI && userIsHDSStaff(auth.user.role),
                },
                {
                    type: 'linkNew',
                    component: 'LCRCarrierLineHaulChargesLink',
                    condition: config.betaURI && userIsHDSStaff(auth.user.role),
                },
                // {
                //     type: 'linkNew',
                //     component: 'LCRCarrierFeesLink',
                //     condition: config.betaURI && userIsHDSStaff(auth.user.role),
                // },
                {
                    type: 'linkNew',
                    component: 'LCRCourierReportDeliveryListLink',
                    condition: config.betaURI && userIsHDSStaff(auth.user.role),
                },
                {
                    type: 'linkNew',
                    component: 'LCRCourierReportClientDeliveryListLink',
                    condition:
                        config.betaURI &&
                        (userIsHDSStaff(auth.user.role) ||
                            clientsHaveConfiguration(
                                clients.items,
                                'leastCostRoutingEnabled',
                                true
                            )),
                },
                {
                    type: 'linkNew',
                    component: 'LCRAmbientBillingLink',
                    condition:
                        config.betaURI &&
                        userIsHDSStaff(auth.user.role) &&
                        userHasFeature(auth.user, 'AmbientBillingReport', '*'),
                },
                {
                    type: 'linkNew',
                    component: 'LCRCourierReportSummaryLink',
                    condition: config.betaURI && userIsHDSStaff(auth.user.role),
                },
                {
                    type: 'linkNew',
                    component: 'LCRPickingLink',
                    condition: config.betaURI && userIsHDSStaff(auth.user.role),
                },
                {
                    type: 'linkNew',
                    component: 'BilledWeightsUploadLink',
                    condition:
                        config.betaURI &&
                        userIsHDSStaff(auth.user.role) &&
                        userHasFeature(auth.user, 'BilledWeightsUpload', '*'),
                },
                {
                    type: 'linkNew',
                    component: 'LCRLocalityLookupLink',
                    condition:
                        config.betaURI &&
                        (userIsHDSStaff(auth.user.role) ||
                            clientsHaveConfiguration(
                                clients.items,
                                'leastCostRoutingEnabled',
                                true
                            )) &&
                        userHasFeature(auth.user, 'LCRv2', '*'),
                },
            ],
        },
        {
            // condition: config.betaURI && userIsHDSStaff(auth.user.role),
            classNames: 'deliveries receival pb-0',
            items: [
                {
                    type: 'heading',
                    text: 'Tools',
                },
                {
                    type: 'linkNew',
                    component: 'UserManagementLink',
                    condition: userHasAccess(auth.user.role, 'user-management'),
                },
                {
                    type: 'linkNew',
                    component: 'UsersAccessRolesLink',
                    condition: userHasFeature(
                        auth.user,
                        'UserAccessRoles',
                        '*'
                    ),
                },
                {
                    type: 'linkNew',
                    component: 'BetaImportLink',
                    condition:
                        config.betaURI &&
                        canUploadCsv &&
                        userHasAccess(auth.user.role, 'upload-manifest'),
                },
                {
                    type: 'linkNew',
                    component: 'PrintOrdersLink',
                    condition: userHasAccess(auth.user.role, 'client-tools'),
                },
                {
                    type: 'linkNew',
                    component: 'PickSheetOrderLink',
                    condition: userHasAccess(
                        auth.user.role,
                        'client-tools-picksheet-order'
                    ),
                },
                {
                    type: 'linkNew',
                    component: 'ForecastDeliveriesLink',
                    condition: userHasAccess(auth.user.role, 'client-tools'),
                },
                {
                    type: 'linkNew',
                    component: 'ForecastRecipesLink',
                    condition: userHasAccess(auth.user.role, 'client-tools'),
                },
                {
                    type: 'linkNew',
                    component: 'AuspostManifestsLink',
                    condition:
                        config.betaURI &&
                        clientsHaveIntegration(clients.items, 'auspost'),
                },
            ],
        },
        {
            condition: null,
            classNames: 'deliveries receival pb-0',
            items: [
                {
                    type: 'linkNew',
                    component: 'DocumentationLink',
                },
            ],
        },
        {
            condition: config.betaURI && userIsHDSStaff(auth.user.role),
            classNames: 'deliveries receival pb-0',
            items: [
                {
                    type: 'heading',
                    text: 'Settings',
                },
                {
                    type: 'linkNew',
                    component: 'ClientsLink',
                    condition: config.betaURI && auth.user.role === 'admin',
                },
                {
                    type: 'linkNew',
                    component: 'DepotsLink',
                    condition: config.betaURI && auth.user.role === 'admin',
                },
                {
                    type: 'linkNew',
                    component: 'BoxSizesLink',
                    condition: config.betaURI && auth.user.role === 'admin',
                },
            ],
        },
        {
            condition: config.betaURI && userIsHDSStaff(auth.user.role),
            classNames: 'deliveries receival pb-0',
            items: [
                {
                    type: 'heading',
                    text: 'Dev',
                },
                {
                    type: 'linkNew',
                    component: 'WebhooksLink',
                    condition: userIsHDSStaff(auth.user.role),
                },
                {
                    type: 'link',
                    component: 'PackerLogsLink',
                    condition: config.betaURI && auth.user.role === 'admin',
                },
                {
                    type: 'linkNew',
                    component: 'AppVersionsLink',
                    condition:
                        config.betaURI &&
                        config.betaURI &&
                        userIsDev(auth.user),
                },
                {
                    type: 'linkNew',
                    component: 'RecurringJobsLink',
                    condition:
                        config.betaURI &&
                        config.betaURI &&
                        userIsDev(auth.user),
                },
                {
                    type: 'linkNew',
                    component: 'TwilioTasksLink',
                    condition:
                        config.betaURI &&
                        config.betaURI &&
                        auth.user.role === 'admin' &&
                        userHasFeature(auth.user, 'TwilioTasksManage', '1'),
                },
                {
                    type: 'linkNew',
                    component: 'DotWMSLogsLink',
                    condition: userIsDev(auth.user),
                },
                {
                    type: 'linkNew',
                    component: 'RDSReconcile',
                    condition: userIsDev(auth.user),
                },
                {
                    type: 'linkNew',
                    component: 'SyncIssueLink',
                    condition: config.betaURI && userIsHDSStaff(auth.user.role),
                },
                {
                    type: 'linkNew',
                    component: 'LocalitiesLink',
                    condition: userIsDev(auth.user),
                },
                {
                    type: 'linkNew',
                    component: 'RunRulesLink',
                    condition: config.betaURI && userIsDev(auth.user),
                },
                {
                    type: 'linkNew',
                    component: 'SevenElevenIntegrationLink',
                    condition:
                        config.betaURI &&
                        (userIsDev(auth.user) ||
                            userHasFeature(
                                auth.user,
                                '7ElevenIntegrationViewer',
                                '1'
                            )),
                },
                {
                    type: 'linkNew',
                    component: 'SevenElevenProcessBatchLink',
                    condition: config.betaURI && userIsDev(auth.user),
                },
                {
                    type: 'linkNew',
                    component: 'NextLink',
                    condition: config.betaURI && userIsDev(auth.user),
                },
                {
                    type: 'linkNew',
                    component: 'ContentTemplateLink',
                    condition: config.betaURI && userIsDev(auth.user),
                },
            ],
        },
        {
            condition:
                config.betaURI &&
                (auth.user.role === 'admin' ||
                    auth.user.role === 'client-admin' ||
                    auth.user.role === 'client-user'),
            classNames: 'deliveries receival pb-0',
            items: [
                {
                    type: 'linkNew',
                    component: 'MyAccountLink',
                    condition:
                        config.betaURI &&
                        (auth.user.role === 'admin' ||
                            auth.user.role === 'client-admin' ||
                            auth.user.role === 'client-user'),
                },
            ],
        },
    ];
};
export default SiteNavItems;
